/**
 * @ngdoc directive
 * @name vLazy
 * @example this should only be added once on <body> tag
 * @returns {boolean}
 */

export default (vue) => {
    vue.el.style.backgroundImage =  'url(\'' + vue.get(vue.arg).replace('\'', '%27') + '\')';
    vue.el.style.backgroundSize = 'cover';
};